import React from 'react';
import { Card, Form, Input, Button } from 'antd';
import './less/ContactForm.less';
import SupportImg from '../assets/images/support.jpg';

function ContactForm() {


  const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
  };

  const validateMessages = {
    required: '${label} را وارد کنید!',
  };

  const onFinish = values => {
  };

  return (
    <Card>

      <div className="ant-row ant-row-rtl">
        <div className="ant-col ant-col-xs-24 ant-col-rtl ant-col-md-14">
          <Form {...layout} name="nest-messages" onFinish={onFinish} validateMessages={validateMessages}>
            <Form.Item name={['user', 'name']} label="نام و نام خانوادگی" rules={[{ required: true }]}>
              <Input />
            </Form.Item>

            <Form.Item name={['user', 'phone']} label="شماره تماس" rules={[{ required: true, type: 'number', min: 0, max: 11 }]}>
              <Input />
            </Form.Item>

            <Form.Item name={['user', 'message']} label="متن پیام" rules={[{ required: true }]}>
              <Input.TextArea />
            </Form.Item>
            <Form.Item wrapperCol={{ ...layout.wrapperCol, offset: 8 }}>
              <Button type="primary" htmlType="submit">
                ارسال پیام
              </Button>
            </Form.Item>
          </Form>
        </div>
        <div className="ant-col ant-col-xs-24 ant-col-rtl ant-col-md-8">

          <img src={SupportImg} alt="تماس با ما" />


        </div>
      </div>




    </Card>




  );
}

export default ContactForm;


